import { CYCLE_AUDIENCE_FILTER_LAYOUT, Pills } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';

const CONJUNCTION_ROW = [
    'flex items-center',
    CYCLE_AUDIENCE_FILTER_LAYOUT.conjunctionGap,
    CYCLE_AUDIENCE_FILTER_LAYOUT.conjunctionBottom,
].join(' ');

const CONJUNCTION_RULE = `flex-1 bg-step-rail-track ${CYCLE_AUDIENCE_FILTER_LAYOUT.conjunctionRule}`;

export const AudienceFilterConjunction = () => {
    const { t } = useAmelioTranslations();

    return (
        <div
            className={CONJUNCTION_ROW}
            data-testid={'audience-filter-conjunction'}
        >
            <span
                className={CONJUNCTION_RULE}
                aria-hidden={true}
            />

            <Pills
                size={'conjunction'}
                variant={'conjunction'}
            >
                {t('cycleEvaluationCycleInformation.audience.filterAnd')}
            </Pills>

            <span
                className={CONJUNCTION_RULE}
                aria-hidden={true}
            />
        </div>
    );
};
